import { createAsyncThunk } from '@reduxjs/toolkit'
import { PerformerController } from 'controller/performer/controller'
import { IPerformerDataActiveTypeticketcollections, IPerformerMetadata } from 'meta/pages/v4/performer'
import { RootState } from 'store/types'

type Params = {
  code: string
  page: number
}

type Returned = {
  data: IPerformerDataActiveTypeticketcollections,
  metadata: IPerformerMetadata,
  code: string
}

export const getActiveTypeticketcollections = createAsyncThunk<Returned, Params, { state: RootState }>(
  'performer/getActiveTypeticketcollections',
  async (params) => {
    const { code, page } = params

    const { data, metadata } = await PerformerController.getActiveTypeticketcollections({ code, page })

    return { data, metadata, code }
  }
)
